import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { ALL } from "app/common/services/categoryService";

import { GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE } from "../const";
import { GrowthOverviewLevel } from "../types";

const ROOT_CATEGORY = "$All";

export const resolveGrowthOverviewCategoryLevelFromForApi = (forApi?: string): GrowthOverviewLevel => {
    const normalized = forApi?.trim() || ROOT_CATEGORY;

    if (normalized === ROOT_CATEGORY || normalized === ALL) {
        return GrowthOverviewLevel.Industries;
    }

    if (normalized.includes("/")) {
        return GrowthOverviewLevel.Domains;
    }

    return GrowthOverviewLevel.SubIndustries;
};

export const resolveGrowthOverviewCategoryLevel = (flattenedCategory?: IFlattenedCategory): GrowthOverviewLevel => {
    if (flattenedCategory?.isChild) {
        return GrowthOverviewLevel.Domains;
    }

    return resolveGrowthOverviewCategoryLevelFromForApi(flattenedCategory?.forApi);
};

export const buildGrowthOverviewRootPaginationParams = (
    flattenedCategory?: IFlattenedCategory,
    pageSize = GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE,
) => {
    const level = resolveGrowthOverviewCategoryLevel(flattenedCategory);

    if (level === GrowthOverviewLevel.Industries) {
        return {
            industryOffset: 0,
            industryLimit: pageSize,
        };
    }

    if (level === GrowthOverviewLevel.SubIndustries) {
        return {
            subIndustryOffset: 0,
            subIndustryLimit: pageSize,
        };
    }

    return {};
};
